import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Add HMR interface
declare const module: any;

bootstrapApplication(AppComponent, appConfig)
  .then(ref => {
    // Enable HMR
    if (module.hot) {
      module.hot.accept();
      module.hot.dispose(() => {
        // Before restarting the app, we create a new root element
        const rootElement = document.createElement('app-root');
        const oldRootElement = document.querySelector('app-root');
        if (oldRootElement && oldRootElement.parentNode) {
          oldRootElement.parentNode.insertBefore(rootElement, oldRootElement);
          oldRootElement.parentNode.removeChild(oldRootElement);
        }
        ref.destroy();
      });
    }
  })
  .catch((err) => console.error(err));
